import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { createAuthGuard } from 'keycloak-angular';
import { AuthService } from '../services/auth.service';

// Use the library's modern factory utility instead of direct inject(KeycloakService)
export const authGuard = createAuthGuard<CanActivateFn>(async (route, state, { keycloak, authenticated }) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // 1. Handle missing authentication
  if (!authenticated && !authService.isAuthenticated()) {
    keycloak.login({
      redirectUri: window.location.origin + state.url
    });
    return false;
  }

  // 2. Fetch expected execution roles for the route
  const requiredRoles = route.data['roles'] as Array<string>;

  // If path doesn't enforce specific roles, authorize navigation
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  // 3. Evaluate if user possesses any of the mandated roles
  // keycloak here is the raw Keycloak client instance supplied by the factory hook
  const keycloakRoles = keycloak.realmAccess?.roles || [];
  const authServiceRoles = authService.currentUser()?.roles || [];
  const userRoles = [...new Set([...keycloakRoles, ...authServiceRoles])];
  const hasRequiredRole = requiredRoles.some((role) => userRoles.includes(role));

  if (hasRequiredRole) {
    return true;
  }

  // 4. Fallback if unauthorized
  router.navigate(['/access-denied']);
  return false;
});